import React from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";

const CancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center p-6">
      <div className="text-center max-w-sm w-full">
        <div className="mb-6 flex justify-center">
          <div className="w-16 h-16 rounded-full border-2 border-[#E7E5E4] flex items-center justify-center">
            <X className="text-[#A8A29E]" size={26} />
          </div>
        </div>

        <p className="text-[10px] tracking-[0.3em] uppercase text-[#A8A29E] mb-3 font-manrope">
          Payment Cancelled
        </p>
        <h1 className="font-playfair text-4xl text-[#1C1917] mb-4 tracking-tight">
          Booking Cancelled
        </h1>
        <p className="text-sm text-[#A8A29E] mb-8 font-manrope leading-relaxed">
          Your payment was cancelled. You can adjust your dates or select a different property and try again.
        </p>

        <button
          data-testid="back-to-portal-btn"
          onClick={() => navigate("/")}
          className="h-12 px-8 bg-[#1C1917] text-[#D4AF37] text-[10px] tracking-widest uppercase font-semibold font-manrope hover:bg-[#292524] transition-colors rounded-sm"
        >
          Back to Portal
        </button>
      </div>
    </div>
  );
};

export default CancelPage;
